<!--
/*
 * @Description: login组件容器
 * @Author: Guojun
 * @Date: 2020-05-19 14:43:48
 * @LastEditTime: 2020-5-20 09:02:47
 */
  -->
<template>
  <div class="model_bg" v-if="show">
    <div class="wrap">
      <i class="el-icon-circle-close icon_close" @click="show=false"></i>
      <Verify
        @success="success"
        :mode="'pop'"
        :captchaType="'blockPuzzle'"
        :imgSize="{ width: '330px', height: '155px' }"
        ref="comverify"
        v-if="isVerify"
      ></Verify>
      <comLogin></comLogin>
      <!-- <div class="right">
        <ul class="title">
          <li
            v-for="(item,index) in tabs"
            :class="index==activeTab?'activeTab':''"
            :key="index"
            @click="tabsClick(index)"
          >{{item}}</li>
          <i class="el-icon-circle-close icon_close" @click="show=false"></i>
        </ul>
        <div class="middle">
          <div v-if="!phoneFirstLogin">
            <phone-login ref="phoneLogin" v-if="activeTab==0"></phone-login>
            <password-login ref="passwordLogin" v-if="activeTab==1"></password-login>
          </div>
          <div v-if="phoneFirstLogin">
            <password-login v-if="activeTab==1"></password-login>
            <setPhone-login v-if="activeTab==0"></setPhone-login>
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import phoneLogin from "./phoneLogin.vue";
import passwordLogin from "./passwordLogin.vue";
import setPhoneLogin from "./setPhoneLogin";
import Verify from "./verifition/Verify";
import comLogin from "./comLogin";
export default {
  data() {
    return {
      activeTab: 0,
      tabs: ["手机快捷登录", "账号密码登录"],
      area: "86",
      isVerify: false,
      captchaVerification: "",
      show: true,
    };
  },
  created() {
    this.$EventBus.$on("close", (data) => {
      this.show = data;
    });
    this.$EventBus.$on("slideShow", (data) => {
      this.isVerify = data;
      this.useVerify();
    });
  },
  mounted() {},
  methods: {
    tabsClick(index) {
      this.activeTab = index;
    },
    beforeDestroy(){
      this.$EventBus.$off('close')
      this.$EventBus.$off('slideShow')
    },
    success(params) {
      // console.log(params);
      this.captchaVerification = params.captchaVerification; //滑动验证码
      this.isVerify = false; //行为验证成功
      this.$EventBus.$emit("verfySuccess", params.captchaVerification);
    },
    useVerify() {
      this.$nextTick(() => {
        this.$refs.comverify.show();
      });
    },
  },
  components: {
    phoneLogin,
    passwordLogin,
    setPhoneLogin,
    comLogin,
    Verify,
  },
};
</script>
 
<style lang="less" scoped>
.model_bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.5);
}
.wrap {
  background-color: #ffffff;
  width: 500px;
  height: 500px;
  z-index: 99;
  padding: 10px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -250px;
  margin-top: -250px;
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  animation-name: wrapscale;
  animation-duration: 300ms;
  animation-iteration-count: 1;
  animation-timing-function: linear;
  animation-delay: 0s;
  @keyframes wrapscale {
    0% {
      top: 100%;
    }
    100% {
      top: 50%;
    }
  }
  .right {
    width: 300px;
    margin: 0 auto;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 70px;
      font-size: 18px;
      color: #333;
      position: relative;
      li {
        flex-basis: 50%;
        border-bottom: 1px solid #e9e9f0;
        line-height: 45px;
        text-align: center;
        cursor: pointer;
      }
      .activeTab {
        border-bottom: 2px solid #fabe00;
        color: #fabe00;
        font-weight: bold;
      }
    }
    .middle {
      margin-top: 54px;
    }
  }
  /deep/.icon_close {
    position: absolute;
    cursor: pointer;
    right: 12px;
    top: 12px;
    font-size: 30px;
  }
}
</style>